import React from "react";
import { Link } from "react-router-dom";
export default function PassWordStatus() {
    return (
      <>
     <div className="EmailVerifyBox verifiedMail passwordStatus">
        <div>
          <img src={'/images/svg/passwordChanged.svg'} className="mx-auto my-3" alt="Email Verification" />
       
          {/* <p>Your Email Has Been Verified</p> */}
          <h2>Your password has been successfully changed.</h2>
          <Link className="btn btn-primary px-5 outline-0 border-0 mt-4" to={'/login'}>Back to login</Link>
        
        </div>
      </div>
       </>
  );
}
